import { Component, OnDestroy, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../shared/services/notification.service';
import { PricingGroupActionData, SpecialPricingSearchEvent } from '../../../shared/services/pricing.service';
import { SpecialPricingGroupTableComponent } from '../special-pricing-group-table/special-pricing-group-table.component';

@Component({
  standalone: false,
  selector: 'app-special-pricing-group-index',
  templateUrl: './special-pricing-group-index.component.html',
  styleUrls: ['special-pricing-group-index.component.scss'],
})
export class SpecialPricingGroupIndexComponent implements OnDestroy {
  @ViewChild(SpecialPricingGroupTableComponent, { static: false }) table: SpecialPricingGroupTableComponent;

  searchControl = new FormControl();
  private searchSubscription: Subscription;

  constructor(
    public router: Router,
    public notificationService: NotificationService,
    titleService: Title
  ) {
    titleService.setTitle('Special pricing');
  }

  groupAction(event: PricingGroupActionData) {
    if (event.name === 'edit') {
      this.router.navigate(['pricing-special', event.row.id]).then();
    }
  }

  onSubmitSearchForm(searchData: SpecialPricingSearchEvent) {
    this.table.requestParams.searchData = searchData;
    this.table.currentPageNumber = 1;
    this.table.update();
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}
